const category = (row) => {
  if (row.capture_trigger === "none" || row.image_status === "not_capture_wake") {
    return { label: "Expected no image", color: "text-slate-600 bg-slate-100" };
  }
  if ((row.image_status || "").startsWith("skipped_")) {
    return { label: "Safety/storage skip", color: "text-amber-700 bg-amber-100" };
  }
  return { label: "Capture/transfer failure", color: "text-red-700 bg-red-100" };
};

export default function CameraMissingPanel({ rows }) {
  if (!rows.length) return null;
  return (
    <details className="rounded-2xl border border-slate-200 bg-white p-4">
      <summary className="cursor-pointer font-bold text-slate-800">
        Wakes without a stored image ({rows.length})
      </summary>
      <div className="mt-3 space-y-2">
        {rows.map((row) => {
          const state = category(row);
          return (
            <div key={row.id} className="flex flex-col gap-1 rounded-xl border border-slate-100 p-3 text-sm sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p>{new Date(row.timestamp).toLocaleString()} · {row.image_status || "unknown"}</p>
                {row.image_error && <p className="text-xs text-red-700">{row.image_error}</p>}
              </div>
              <span className={`w-fit rounded-full px-2 py-1 text-xs font-bold ${state.color}`}>{state.label}</span>
            </div>
          );
        })}
      </div>
    </details>
  );
}
